"use strict";exports.__esModule = true;exports.fontSize = fontSize;exports.lineHeight = lineHeight;exports.paddingX = paddingX;exports.paddingY = paddingY;


function fontSize(t, size) {
  return mapSize(size, t.tabFontSizeSmall, t.tabFontSizeMedium, t.tabFontSizeLarge);
}

function lineHeight(t, size) {
  return mapSize(size, t.tabLineHeightSmall, t.tabLineHeightMedium, t.tabLineHeightLarge);
}

function paddingX(t, size) {
  return mapSize(size, t.tabPaddingXSmall, t.tabPaddingXMedium, t.tabPaddingXLarge);
}

function paddingY(t, size) {
  return mapSize(size, t.tabPaddingYSmall, t.tabPaddingYMedium, t.tabPaddingYLarge);
}

function mapSize(size, small, medium, large) {
  switch (size) {
    case 'small':
      return small;
    case 'medium':
      return medium;
    case 'large':
      return large;
    default:
      return small;
  }
}